import React from 'react';
import PropTypes from 'prop-types';

import MuiPaper from '@material-ui/core/Paper';

import { usePaperStyles } from './styles';

const Paper = ({ children, flexGrow, noBorder, grey, padding, ...rest }) => {
	const paperClasses = usePaperStyles({
		flexGrow,
		noBorder,
		grey,
		padding
	});

	return (
		<MuiPaper {...rest} classes={paperClasses}>
			{children}
		</MuiPaper>
	);
};

Paper.propTypes = {
	children: PropTypes.node.isRequired,
	flexGrow: PropTypes.number,
	noBorder: PropTypes.bool,
	grey: PropTypes.bool,
	padding: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)])
};

export default Paper;
